import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/products/$slug")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/products/:slug' }),
  beforeLoad: ({ params }) => {
    // Legacy parts URLs: permanently redirect to the canonical catalog path
    // so Google stops reporting duplicate / user-declared-canonical errors.
    throw redirect({
      href: `/parts-catalog/${params.slug}`,
      statusCode: 301,
      throw: true,
    });
  },
});
